module.exports = __webpack_public_path__ + "img/logo.ff320ec3.png";